import styled from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import { device } from '@/styles/helpers';

const bg = getCDNImageUrl('/networks/bg.jpg');

export const ScNetworksModalContainer = styled.div`
  padding: 8px;
  width: 100%;
`;

export const ScNetworksModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 32px 188px;
  gap: 32px;
  margin: 0 auto;

  position: relative;
  max-width: 640px;
  width: 100%;

  border-radius: 24px;
  background-image: url(${bg});
  background-size: cover;
  background-position: top center;

  & > .text {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;

    .title {
      font-weight: 700;
      font-size: 22px;
      line-height: 28px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      padding: 0 20px;
    }

    .descr {
      font-size: 16px;
      line-height: 24px;
    }
  }

  & > .network-items {
    display: grid;
    gap: 12px;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
  }

  & > .characters {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }

  @media (${device.mobileS}) {
    padding: 32px 16px 188px;
    max-width: 100%;

    & > .text {
      .title {
        font-size: 20px;
        line-height: 26px;
        padding: 0 36px;
      }
    }

    & > .network-items {
      display: flex;
      flex-direction: column;
    }
  }
`;
